import Header from '../utill/Header'
import Footer from '../utill/Footer'
import Sidebar from '../utill/Sidebar'
import React, {ChangeEvent, useContext, useEffect, useState} from "react";
import {Card, Form, Table} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import Url from "../utill/Url";
import axios from "axios";
import {useSelector} from "react-redux";
import {reissue} from "../utill/UtilComponent";
import styles from "../../css/Authority.module.css";
import {RootState} from "../../redux/store";

function OrderingSerialNumber() {
    const url = useContext(Url)
    const navigate = useNavigate();
    const user = useSelector((state: RootState) => state.user.value);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [selected, setSelected] = useState("1");
    const [deviceSelected, setDeviceSelected] = useState("0");
    const [deviceType, setDeviceType] = useState<DeviceType[]>([]);
    const [serialError, setSerialError] = useState('');
    const [releaseError, setReleaseError] = useState('');
    const [inputValue, setInputValue] = useState("");
    const [disabled, setDisabled] = useState(false);
    const [isIdAvailable, setIsIdAvailable] = useState(false);
    const [overlap, setOverlap] = useState(false);
    const [customerCode, setCustomerCode] = useState<CustomerCode[]>([]);
    const [customerCodeSelected, setCustomerCodeSelected] = useState("");
    const auth = useSelector((state: RootState) => state.loginAuth.value);
    const [serial, setSerial] = useState({
        serialNumber: '',
        description: '',
        releaseNo: '',
        deviceType: ''
    });
    let userId = user.id;

    useEffect(() => {
        document.title = "Mcon 모니터링 시스템-시리얼 번호 발주"
        if (auth.MENUAUTH?.DEV0000?.readAuthorityYn !== "1" && auth.MENUAUTH?.DEV0000?.writeAuthorityYn !== "1") {
            alert('페이지를 볼 수 있는 권한이 없습니다.');
            navigate(auth.firstUrl);
        } else if (auth.MENUAUTH?.DEV0000?.writeAuthorityYn !== "1") {
            alert('페이지를 볼 수 있는 권한이 없습니다.');
            navigate('/DeviceManagement');
        }
        reissue(userId, url, navigate).then(() => {
            axios.get(url + 'device/devicetype', {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            }).then((response) => {
                setDeviceSelected(response.data.result[0].type)
                setSerial({...serial, deviceType: response.data.result[0].type})
                setDeviceType(response.data.result)
            })
            axios.get(url + 'customercode/findall', {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            }).then((response) => {
                setCustomerCode(response.data.result.data)
                setCustomerCodeSelected(response.data.result.data[0].customerCode)
            })
        });
    }, []);

    useEffect(() => {
        if (inputValue.length >= 10) {
            setReleaseError('릴리즈 번호는 9자가 최대입니다');
            setDisabled(true);
        } else {
            setReleaseError('');
            setDisabled(false);
        }
    }, [inputValue]);

    const handleChangeSelect = (e: ChangeEvent<HTMLSelectElement>) => {
        setSelected(e.target.value)
    }
    const handleChangeDeviceSelect = (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        setDeviceSelected(e.target.value)
        setSerial({...serial, [e.target.name]: e.target.value});
    }

    const handleFileDownload = () => {
        reissue(userId, url, navigate).then(() => {
            const excelUrl = process.env.PUBLIC_URL+'/statics/시리얼번호발주포맷.xlsx';
            const link = document.createElement('a');
            link.href = excelUrl;
            link.download = '시리얼번호발주포맷.xlsx';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
    }

    const handleReleaseChange = (e: ChangeEvent<HTMLInputElement>) => {
        setSerial({...serial, [e.target.name]: e.target.value});
        setInputValue(e.target.value);
    };

    const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        const fileInput = e.target as HTMLInputElement;
        if (fileInput.files && fileInput.files[0]) {
            setSelectedFile(fileInput.files[0]);
        }
    };

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        setSerial({...serial, [e.target.name]: e.target.value});
    };
    const handleSerialChange = (e: ChangeEvent<HTMLInputElement>) => {
        setSerial({...serial, [e.target.name]: e.target.value});
        setSerialError('');
        setIsIdAvailable(false);
    };

    const handleSerialSubmit = () => {
        reissue(userId, url, navigate).then(() => {
                if (!serial.serialNumber) {
                    setSerialError('시리얼 번호는 필수 입력 항목입니다.');
                    return;
                } else if (!isIdAvailable) {
                    setOverlap(true);
                    return;
                } else if (isNaN(Number(serial.releaseNo))) {
                    alert('릴리즈 번호는 숫자로 입력해주세요')
                    return;
                }
                const isAction = window.confirm('업로드 하시겠습니까?');
                if (isAction) {
                    try {
                        axios.post(url + 'device/create', {
                            serialNumber: serial.serialNumber,
                            description: serial.description,
                            releaseNo: serial.releaseNo,
                            deviceType: serial.deviceType,
                            customerCode: customerCodeSelected
                        }, {
                            headers: {
                                'Authorization': localStorage.getItem('Authorization')
                            }
                        }).then((res) => {
                            alert('시리얼번호 발주 완료 하셨습니다.')
                            navigate('/DeviceManagement')
                        })
                    } catch (e) {
                        console.error(e);
                        alert('시리얼번호를 발주하는데 실패하셨습니다.\n파일을 다시 확인해 주시기 바랍니다.')
                    }
                }
            }
        )
    }

    const handleCheckSerialNumber = () => {
        reissue(userId, url, navigate).then(() => {
            if (!serial.serialNumber) {
                setSerialError('시리얼 번호를 입력하세요');
            } else {
                axios.get(url + `device/serialcheck`, {
                    headers: {
                        'Authorization': localStorage.getItem('Authorization')
                    },
                    params: {
                        serialNumber: serial.serialNumber
                    }
                })
                    .then(response => {
                        if (response.data.code === 200) {
                            setSerialError('사용 가능한 시리얼 번호입니다.');
                            setIsIdAvailable(true);
                            setOverlap(false);
                        } else {
                            setSerialError('중복된 시리얼 번호입니다.');
                            setIsIdAvailable(false);
                            setOverlap(false);
                        }
                    })
                    .catch(error => {
                        console.error('시리얼번호 중복 확인 실패:', error);
                    });
            }
        })
    };

    const handleSubmit = () => {
        const file = new FormData();
        if (selectedFile) {
            file.append('file', selectedFile);
        } else {
            console.error('No file selected')
        }

        reissue(userId, url, navigate).then(() => {
            axios.post(url + 'device/addexcel', file, {
                headers: {
                    'Authorization': localStorage.getItem('Authorization'),
                    'Content-Type': 'multipart/form-data'
                },
            }).then((data) => {
                if(data.data.code === 400){
                    alert(data.data.message)
                }
                else {
                    alert('시리얼번호 발주 완료')
                    navigate('/DeviceManagement')
                }
            }).catch((e) => {
                console.log(e)
                alert('시리얼번호를 발주하는데 실패하셨습니다.\n파일을 다시 확인해 주시기 바랍니다.')
            })
        })
    }

    const handleChangeCustomerCodeSelect = (e: ChangeEvent<HTMLSelectElement>) => {
        setCustomerCodeSelected(e.target.value)
    }

    let selectedValueContent = "";

    if (selected === "1") {
        selectedValueContent = "직접 입력 후"
    } else if (selected === "2") {
        selectedValueContent = "엑셀 파일을"
    }

    const handleModifyCancel = () => {
        const Cancel = window.confirm('취소하시겠습니까?\n수정중인 내용이 모두 삭제됩니다.');
        if (Cancel) {
            navigate('/DeviceManagement');
        }
    }

    return (
        <div id="wrapper">
            <Sidebar menuCode={"DEV0000"}/>
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <div className="container-fluid">
                        <Header pageName="시리얼 번호 발주"/>
                        <Card className="card shadow mb-4">
                            <Card.Header>
                                    <h6 className="below">{selectedValueContent} 업로드하여 시리얼 발주를 진행합니다.</h6>
                                    <Form.Select className="select_custom" id='search_select' value={selected}
                                                 onChange={handleChangeSelect}>
                                        <option value="1">직접 입력</option>
                                        <option value="2">Excel</option>
                                    </Form.Select>
                                {selected === "1" && <p style={{fontSize:'14px'}} className="before_required">표시는 필수 입력 항목입니다.</p>}
                            </Card.Header>
                            <Card.Body>
                                    {selected === "1" ? (<div>
                                        <Table bordered>
                                            <tbody>
                                            <tr>
                                                <td id="front_line" className={styles.tableHead}><p className="after_required">시리얼 번호</p></td>
                                                <td id="back_line">
                                                    <Form.Control type="text" placeholder="시리얼 번호" name="serialNumber"
                                                                  value={serial.serialNumber} onChange={handleSerialChange}/>
                                                    <button onClick={handleCheckSerialNumber} className="btn btn-primary" style={{marginLeft:'1rem'}}
                                                            type="button">중복확인</button>
                                                    {serialError && <p id="serial_error">{serialError}</p>}
                                                    {overlap && <p id="serial_error">시리얼번호 중복확인이 필요합니다</p>}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td id="front_line" className={styles.tableHead}><p>설명</p></td>
                                                <td id="back_line"><Form.Control type="text" placeholder="설명"
                                                                                        name="description" value={serial.description}
                                                                                        onChange={handleChange}/></td>
                                            </tr>
                                            <tr>
                                                <td id="front_line" className={styles.tableHead}><p>릴리즈 번호</p></td>
                                                <td id="back_line"><Form.Control type="text" placeholder="릴리즈 번호"
                                                                                        name="releaseNo" value={serial.releaseNo}
                                                                                        onChange={handleReleaseChange}/>
                                                {releaseError && <p id="release_error">{releaseError}</p>}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td id="front_line" className={styles.tableHead}><p>디바이스 타입</p></td>
                                                <td id="back_line"><Form.Select placeholder="디바이스 타입" name="deviceType"
                                                                                value={deviceSelected} style={{color:"black", width:"30rem"}}
                                                                                onChange={handleChangeDeviceSelect}>
                                                    {deviceType.map(deviceType => (
                                                    <option key={deviceType.type}
                                                            value={deviceType.type}>{deviceType.description}</option>
                                                    ))}</Form.Select></td>
                                            </tr>
                                            <tr>
                                                <td id="front_line" className={styles.tableHead}><p>고객사 코드</p></td>
                                                <td id="back_line"><Form.Select className="select_box" value={customerCodeSelected} style={{color:"black", width:"30rem"}}
                                                                                onChange={handleChangeCustomerCodeSelect} name="customerCode">
                                                    {customerCode.map(customerCode => (
                                                        <option key={customerCode.customerCode}
                                                                value={customerCode.customerCode}>{customerCode.customerName}</option>
                                                    ))}
                                                </Form.Select></td>
                                            </tr>
                                            </tbody>
                                        </Table>
                                    </div>) : (<div style={{marginTop:'1rem'}}>
                                            <Form.Group className="col_b">
                                                <div className="back_line" style={{textAlign:'center'}}><Form.Control onChange={handleFileChange}
                                                                                         type="file"
                                                                                         id="multipartFile"
                                                                                         name="files"/>
                                                    <button className="btn btn-primary format"
                                                            onClick={handleFileDownload}>포맷 다운로드
                                                    </button>
                                                </div>
                                            </Form.Group>
                                        </div>
                                    )}
                                    {selected === "1" ? (<div>
                                            <div className="btn modify">
                                                <button className="btn btn-primary" disabled={disabled}
                                                        onClick={handleSerialSubmit}>등록
                                                </button>
                                                <button className="btn btn-danger"
                                                        onClick={handleModifyCancel}>취소
                                                </button>
                                            </div>
                                        </div>
                                    ) : (<div className="btn modify">
                                            <button className="btn btn-primary" onClick={handleSubmit}>등록
                                            </button>
                                            <button className="btn btn-danger" onClick={handleModifyCancel}>취소
                                            </button>
                                        </div>
                                    )}
                            </Card.Body>
                        </Card>
                    </div>
                </div>
                <Footer/>
            </div>
        </div>
    )
}

export default OrderingSerialNumber;